import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {RestResources} from "../services/rest_resources";
import { ITypes } from '../types';


interface IResourcesState {
    dataResources: [];
    dataTypeContainers: Array<ITypes>
    dataTypeQuality: Array<ITypes>
    dataTypeQualityEn: Array<ITypes>
    dataTypeDepartment: Array<ITypes>
    dataTypeDepartmentEn: Array<ITypes>
    hasFetchedResources: boolean,
}

const initialState: IResourcesState = {
    dataResources: [],
    dataTypeContainers: [],
    dataTypeQuality: [],
    dataTypeQualityEn: [],
    dataTypeDepartment: [],
    dataTypeDepartmentEn: [],
    hasFetchedResources: false,
}

export const getResources = createAsyncThunk(
    'getResources',
    async () => {
        return await RestResources.getResources()
    }
)

const resourcesSlice = createSlice({
    name: 'resources',
    initialState,
    reducers: {
        setFetchedResources(state, action) {
            state.hasFetchedResources = action.payload
        },
        setTypeContainers(state, action) {
            state.dataTypeContainers = action.payload
        },
        setTypeQuality(state, action) {
            state.dataTypeQuality = action.payload
        },
        setTypeQualityEn(state, action) {
            state.dataTypeQualityEn = action.payload
        },
        setTypeDepartment(state, action) {
            state.dataTypeDepartment = action.payload
        },
        setTypeDepartmentEn(state, action) {
            state.dataTypeDepartmentEn = action.payload
        },
    }
})
export default resourcesSlice.reducer;
export const {
    setFetchedResources,
    setTypeContainers,
    setTypeQuality,
    setTypeQualityEn,
    setTypeDepartment,
    setTypeDepartmentEn
} = resourcesSlice.actions
